import { AppRoutes } from '../const/AppRoutes';
import { SearchResultsTypeEnum } from '../content/search-results/SearchResultsTypeEnum';

/**
 * URL de fiche d'un résultat de recherche globale (type = class_basename côté API).
 * Même table que SearchResultsComponent.getItemURL, réutilisée par le type-ahead.
 */
export function searchResultUrl(item: {
  type: string;
  subtype?: string | null;
  slug: string;
  uuid: string;
}): string {
  const slug: string = item.slug ? item.slug : '-';
  switch (item.type) {
    case SearchResultsTypeEnum.PROJECT:
      return '/' + AppRoutes.PROJECT + '/' + slug + '/' + item.uuid;
    case SearchResultsTypeEnum.CONGRESS:
      return '/' + AppRoutes.CONGRES + '/' + slug + '/' + item.uuid;
    case SearchResultsTypeEnum.CLIENT:
      return '/' + AppRoutes.CLIENTS + '/' + slug + '/' + item.uuid;
    case SearchResultsTypeEnum.ENTERPRISE:
      return '/' + AppRoutes.ENTERPRISES + '/' + slug + '/' + item.uuid;
    case SearchResultsTypeEnum.EMPLOYEE:
      return '/' + AppRoutes.EMPLOYEES + '/' + slug + '/' + item.uuid;
    case SearchResultsTypeEnum.PLACE:
      return '/' + AppRoutes.VENUES + '/' + slug + '/' + item.uuid;
    case SearchResultsTypeEnum.ROOM:
      return '/' + AppRoutes.ROOMS + '/' + slug + '/' + item.uuid + '?loc=Places';
    case SearchResultsTypeEnum.PRODUCT:
      return '/' + AppRoutes.PRODUCTS + '/' + slug + '/' + item.uuid;
    case SearchResultsTypeEnum.MATERIAL:
    case SearchResultsTypeEnum.MATERIAL2:
      return '/' + AppRoutes.MATERIALS + '/' + slug + '/' + item.uuid;
    case SearchResultsTypeEnum.PROPOSAL:
      return '/' + AppRoutes.PROPOSITIONS + '/' + slug + '/' + item.uuid;
    case SearchResultsTypeEnum.EVENT:
      return '/' + AppRoutes.EVENTS + '/' + slug + '/' + item.uuid;
    case SearchResultsTypeEnum.ORDER: {
      const subtype = (item.subtype || '').toUpperCase();
      if (subtype === 'PROPOSAL' || subtype === 'PROPOSITION') {
        return '/' + AppRoutes.PROPOSITIONS + '/' + slug + '/' + item.uuid;
      }
      if (subtype === 'INVOICE' || subtype === 'FACTURE') {
        return '/' + AppRoutes.INVOICES + '/' + slug + '/' + item.uuid;
      }
      return '/' + AppRoutes.ORDERS + '/' + slug + '/' + item.uuid;
    }
    default:
      return '';
  }
}

/** Icône Material du type de résultat (mêmes clés que IconsService). */
export function searchResultIconKey(item: { type: string; subtype?: string | null }): string {
  switch (item.type) {
    case SearchResultsTypeEnum.ORDER: {
      const subtype = (item.subtype || '').toUpperCase();
      if (subtype === 'PROPOSAL') {
        return 'PROPOSAL';
      }
      if (subtype === 'INVOICE') {
        return 'INVOICE';
      }
      return 'ORDER';
    }
    case SearchResultsTypeEnum.PROPOSAL:
      return 'PROPOSAL';
    case SearchResultsTypeEnum.MATERIAL:
    case SearchResultsTypeEnum.MATERIAL2:
      return 'MATERIAL';
    default:
      // CLIENT, EMPLOYEE, ENTERPRISE, PLACE, ROOM, PRODUCT, EVENT, CONGRESS, PROJECT : clés IconsService
      return item.type.toUpperCase();
  }
}
